import { AbstractDTO } from '../abstract';
import {ILanguage} from "@signature-it/ngx-generic/interfaces";
import {RuleFormDTO} from "./rule-form";

export class RuleFormRequestDTO extends AbstractDTO {
	collectionVar: string;
	lang: ILanguage;
	productId: number;
	isTestScenario: boolean;
	forceState: string|null;
	ruleId: number|null;
	testId: number|null;
	pidForDefaultValues: number|null;
	ruleFormDTO;

	constructor(attributes?: Object) {
		super(attributes);
		attributes = attributes ? attributes : {};
		this.lang = attributes['lang'];
		this.productId = attributes['productId'];
		this.isTestScenario = attributes['isTestScenario'] || false;
		this.forceState = attributes['forceState'];
		this.ruleId = attributes['ruleId'];
		this.collectionVar = attributes['collectionVar'];
		this.testId = attributes['testId'];
		this.pidForDefaultValues = attributes['pidForDefaultValues'];
		this.ruleFormDTO = attributes['ruleFormDTO'] || RuleFormDTO;
	}

}
